import { DBPopover } from "@db-ux/react-core-components";
import React from "react";
import type { ComponentProps } from "react";

type REDPopoverProps = ComponentProps<typeof DBPopover>;

const REDPopover = React.forwardRef<HTMLElement, REDPopoverProps>((props, ref) => {
    return <DBPopover ref={ref} {...props}>{props.children}</DBPopover>;
});

REDPopover.displayName = "REDPopover";

export default REDPopover;